var _circle, _path, _path2, _path3, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2086,
    cy: 17.7013,
    r: 16.5162,
    fill: "white",
    stroke: "#00285B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2126 13.2719C17.9705 13.2719 18.5849 13.8863 18.5849 14.6442V24.8188C18.5849 25.5767 17.9705 26.1911 17.2126 26.1911C16.4547 26.1911 15.8403 25.5767 15.8403 24.8188V14.6442C15.8403 13.8863 16.4547 13.2719 17.2126 13.2719Z",
    fill: "#01285B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9639 24.8184C20.9639 25.5763 20.3495 26.1907 19.5916 26.1907L14.8255 26.1907C14.0676 26.1907 13.4532 25.5763 13.4532 24.8184C13.4532 24.0606 14.0676 23.4462 14.8255 23.4462L19.5916 23.4462C20.3495 23.4462 20.9639 24.0606 20.9639 24.8184Z",
    fill: "#01285B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4973 14.0937C18.7566 14.8058 18.3897 15.5938 17.6777 15.8537L15.4388 16.6708C14.7269 16.9307 13.9395 16.564 13.6802 15.8518C13.4209 15.1397 13.7879 14.3517 14.4998 14.0919L16.7387 13.2747C17.4507 13.0149 18.238 13.3815 18.4973 14.0937Z",
    fill: "#01285B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1035,
    cy: 10.0672,
    r: 1.68942,
    fill: "#01285B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconLines);
export default __webpack_public_path__ + "static/media/infoIconLines.0931a2df695c09c335ff5bf43b283292.svg";
export { ForwardRef as ReactComponent };